import { render, staticRenderFns } from "./ReMessengersTemplate.vue?vue&type=template&id=10b59caa&scoped=true"
import script from "./ReMessengersTemplate.vue?vue&type=script&lang=js"
export * from "./ReMessengersTemplate.vue?vue&type=script&lang=js"
import style0 from "./ReMessengersTemplate.vue?vue&type=style&index=0&id=10b59caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b59caa",
  null
  
)

export default component.exports